import React from "react";
import { Text, View } from "react-native";
import { AppFontStyle } from "../../styles/AppFontStyle";

const HelpCenterStaticPageComponent = ({ heading, subHeading, steps }) => {
  return (
    <View>
      {/* Heading */}
      {heading && (
        <Text
          style={[
            AppFontStyle.BOLD_ANYBODY_18, // Bold heading style
            { marginBottom: 10 },
          ]}
        >
          {heading}
        </Text>
      )}

      {/* Subheading */}
      {subHeading && (
        <Text
          style={[
            AppFontStyle.REGULAR_ANYBODY_14, // Regular subheading style
            { marginBottom: 20 },
          ]}
        >
          {subHeading}
        </Text>
      )}

      {/* Steps and Substeps */}
      {steps && steps.length > 0 && (
        <View>
          {steps.map((step, index) => (
            <View key={`step-${index}`} style={{ marginBottom: 20 }}>
              {/* Step Title */}
              <Text
                style={[AppFontStyle.REGULAR_ANYBODY_12, { marginBottom: 10 }]}
              >
                {step.title}
              </Text>

              {/* Step Content (With Bullet Points) */}
              {step.content && step.content.length > 0 && (
                <View style={{ paddingLeft: 20 }}>
                  {step.content.map((item, i) => (
                    <View
                      key={`content-item-${i}`}
                      style={{
                        flexDirection: "row",
                        alignItems: "flex-start",
                        marginBottom: 5,
                      }}
                    >
                      <Text style={{ lineHeight: 20, color: "white" }}>•</Text>
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_12,
                          {
                            flexShrink: 1,
                            marginLeft: 5,
                            lineHeight: 20,
                          },
                        ]}
                      >
                        {item}
                      </Text>
                    </View>
                  ))}
                </View>
              )}

              {/* SubContent (Bullet Points within content) */}
              {step.subContent && step.subContent.length > 0 && (
                <View style={{ paddingLeft: 30 }}>
                  {step.subContent.map((subItem, i) => (
                    <View
                      key={`subContent-item-${i}`}
                      style={{
                        flexDirection: "row",
                        alignItems: "flex-start",
                        marginBottom: 5,
                      }}
                    >
                      <Text style={{ lineHeight: 20, color: "white" }}>•</Text>
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_12,
                          {
                            flexShrink: 1,
                            marginLeft: 5,
                            lineHeight: 20,
                          },
                        ]}
                      >
                        {subItem}
                      </Text>
                    </View>
                  ))}
                </View>
              )}

              {/* Substeps */}
              {step.subSteps && step.subSteps.length > 0 && (
                <View style={{ marginLeft: 20 }}>
                  {step.subSteps.map((subStep, subIndex) => (
                    <View
                      key={`subStep-${subIndex}`}
                      style={{ marginBottom: 10 }}
                    >
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_12,
                          { fontWeight: "bold" },
                        ]}
                      >
                        {subStep.subTitle}
                      </Text>
                      <View style={{ paddingLeft: 15 }}>
                        {subStep.subContent &&
                          subStep.subContent.length > 0 && (
                            <View>
                              {subStep.subContent.map((subItem, i) => (
                                <View
                                  key={`subContent-${i}`}
                                  style={{
                                    flexDirection: "row",
                                    alignItems: "flex-start",
                                    marginBottom: 5,
                                  }}
                                >
                                  <Text
                                    style={{ lineHeight: 20, color: "white" }}
                                  >
                                    •
                                  </Text>
                                  <Text
                                    style={[
                                      AppFontStyle.REGULAR_ANYBODY_12,
                                      {
                                        flexShrink: 1,
                                        marginLeft: 5,
                                        lineHeight: 20,
                                      },
                                    ]}
                                  >
                                    {subItem}
                                  </Text>
                                </View>
                              ))}
                            </View>
                          )}
                      </View>
                    </View>
                  ))}
                </View>
              )}
            </View>
          ))}
        </View>
      )}
    </View>
  );
};

export default HelpCenterStaticPageComponent;
